import './CandidateInformationMobile.scss';
import Container from 'components/molecules/Container/Container';
import { Maybe } from 'generated/graphql';
import { FC } from 'react';
import CandidateInformationContainer from 'views/CandidateInformation/CandidateInformationContainer/CandidateInformationContainer';
import { Modal, ModalSize } from '@spotted-zebra-uk/ui-components';

interface ICandidateInformationMobile {
  stageCandidateId: number;
  companyLogoUrl?: Maybe<string>;
  onCloseModal: () => void;
}

const CandidateInformationMobile: FC<ICandidateInformationMobile> = ({
  stageCandidateId,
  companyLogoUrl,
  onCloseModal,
}) => {
  return (
    //@ts-ignore
    <Modal
      className="CandidateInformationDesktop"
      onClose={onCloseModal}
      isOpen
      modalSize={ModalSize.SMALL}
    >
      <Container className="CandidateInformationMobile">
        <CandidateInformationContainer
          stageCandidateId={stageCandidateId}
          companyLogoUrl={companyLogoUrl}
          onCandidateInformationProvided={onCloseModal}
          onCandidateInformationFormPreviouslyCompleted={onCloseModal}
        />
      </Container>
    </Modal>
  );
};

export default CandidateInformationMobile;
